export enum PayementStatus {
  UNPAID = "UNPAID",
  DELEGATION_WAITING_FOR_VALIDATION = "DELEGATION_WAITING_FOR_VALIDATION", // for transfer payment
  DELEGATION_PAID_CARD = "DELEGATION_PAID_CARD",
  DELEGATION_PAID_TRANSFER = "DELEGATION_PAID_TRANSFER",
  PERSONAL_WAITING_FOR_VALIDATION = "PERSONAL_WAITING_FOR_VALIDATION", // for transfer payment
  PERSONAL_PAID_CARD = "PERSONAL_PAID_CARD",
  PERSONAL_PAID_TRANSFER = "PERSONAL_PAID_TRANSFER",
}
